module.exports = __webpack_public_path__ + "22fd132f2e2002aae156b6906835d10f.svg";